export enum CardsSortEnum {
  NEWEST_TO_OLDEST = "individual_card.date_added_newest_to_oldest",
  OLDEST_TO_NEWEST = "individual_card.date_added_oldest_to_newest",
  A_TO_Z = "individual_card.alphabetical_a_to_z",
  Z_TO_A = "individual_card.alphabetical_z_to_a",
  DEFAULT = "def",
}

export class CardsSortUtil {
  public static getSortDirectionBySort(sort: CardsSortEnum) {
    switch (sort) {
      case CardsSortEnum.NEWEST_TO_OLDEST:
      case CardsSortEnum.Z_TO_A:
        return "DESC"

      case CardsSortEnum.A_TO_Z:
      case CardsSortEnum.OLDEST_TO_NEWEST:
        return "ASC"

      case CardsSortEnum.DEFAULT:
        return undefined;
    }
  }

  public static getSortFieldBySort(sort: CardsSortEnum) {
    switch (sort) {
      case CardsSortEnum.NEWEST_TO_OLDEST:
      case CardsSortEnum.OLDEST_TO_NEWEST:
        return "createdDate"
      case CardsSortEnum.Z_TO_A:
      case CardsSortEnum.A_TO_Z:
        return "name"

      case CardsSortEnum.DEFAULT:
        return undefined;
    }
  }
}
